import { JSX, memo } from 'react';

import { RipsLogo } from '@/assets/icons/RipsLogo';
import ArcadeLogo from '@/assets/icons/arcadeLogo';
import CasinoLogo from '@/assets/icons/casinoLogo';
import PicksLogo from '@/assets/icons/picksLogo';
import PredictionLogo from '@/assets/icons/predictionsLogo';
import SweepsLogo from '@/assets/icons/sweepsLogo';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { useUserStore } from '@/hooks/use-user-store';

import { BetrBucksBalanceButton, CashBalanceButton } from './BalanceButton';
import { Row } from './lib/components';

export const NAV_BAR_HEIGHT = 48;

type AppNavBarProps = {
    hideBetrBucks?: boolean;
    extraElement?: JSX.Element;
};

/**
 * Top app nav bar, showing the product switch menu and the balances buttons.
 */
export const AppNavBar = memo(({ hideBetrBucks = false, extraElement }: AppNavBarProps) => {
    const activeProduct = useJurisdictionStore(state => state.product);

    const guest = useUserStore(state => state.guest);

    return (
        <MaxWidthWrapper height={NAV_BAR_HEIGHT}>
            <Row flex={1} px="s16" justifyContent={'space-between'} alignItems="center" width="100%" py={'s6'}>
                {activeProduct !== Product.None ? logoMap[activeProduct] : null}
                {guest ? null : (
                    <Row gap={'s8'} flex={1} justifyContent={'flex-end'}>
                        {hideBetrBucks ? null : <BetrBucksBalanceButton />}
                        {extraElement}
                        <CashBalanceButton />
                    </Row>
                )}
            </Row>
        </MaxWidthWrapper>
    );
});

export const logoMap = {
    [Product.Pickem]: <PicksLogo testID="pickm-logo" />,
    [Product.Arcade]: <ArcadeLogo />,
    [Product.Sweeps]: <SweepsLogo />,
    [Product.Casino]: <CasinoLogo />,
    [Product.Prediction]: <PredictionLogo />,
    [Product.Rips]: <RipsLogo testID="rips-logo" />,
} as const;
